import { Search } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import Stack from '@mui/material/Stack';
import Popup from '@shared/components/Popup';
import ProductLookup from '@shared/components/ProductLookup';
import { useUserProductsAndTenorsContext } from '@shared/contexts/UserProductsAndTenorsProvider';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { allReferenceMenuOptions } from './ReferenceMenuOptions';

export const ReferenceMenuPopup = props => {
  const [lookupOpen, setLookupOpen] = useState(false);
  const { userProducts } = useUserProductsAndTenorsContext();

  return (
    <>
      <Popup offset={[0, 20]} arrow {...props}>
        <Stack direction="column" style={{ marginTop: 0, marginBottom: 0 }}>
          <List>
            {allReferenceMenuOptions.map(({ name, path, Icon }) => (
              <ListItem key={path} disablePadding>
                <Link to={path} style={{ color: 'inherit', textDecoration: 'none' }}>
                  <ListItemButton onClick={props.onClose}>
                    <ListItemIcon style={{ fontSize: 20 }}>{Icon}</ListItemIcon>
                    <ListItemText primary={name} />
                  </ListItemButton>
                </Link>
              </ListItem>
            ))}

            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  setLookupOpen(true);
                  props.onClose();
                }}
              >
                <ListItemIcon style={{ fontSize: 20 }}>
                  <Search sx={{ fontSize: 15 }} />
                </ListItemIcon>
                <ListItemText primary="Product Lookup" />
              </ListItemButton>
            </ListItem>
          </List>
        </Stack>
      </Popup>
      <Dialog
        keepMounted
        open={lookupOpen}
        onClose={() => setLookupOpen(false)}
        fullWidth
        maxWidth="xl"
        sx={{ '& .MuiDialog-paper': { overflow: 'hidden' } }}
      >
        <DialogTitle sx={{ margin: 0, padding: '2px 2px 0 0 ', textAlign: 'right' }}>
          <IconButton onClick={() => setLookupOpen(false)}>
            <span className="ri-close-line" aria-hidden="true" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ position: 'relative', overflow: 'auto', height: '90vh' }}>
          <ProductLookup
            items={userProducts.map(product => ({ id: product.id.toString(), name: product.full_name, secondaryName: product.short_name }))}
            expanded={lookupOpen}
            onClose={() => setLookupOpen(false)}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
